import React from "react";

const steps = [
  {
    number: 1,
    name: "Get Started",
    disabled: false,
  },
  {
    number: 2,
    name: "Choose Assessments",
    disabled: true,
  },
  {
    number: 3,
    name: "Customize",
    disabled: true,
  },
  {
    number: 4,

    name: "Configure & Launch",
    disabled: true,
  },
];

function Stepper(props) {
  let { current, children } = props;
  return (
    <div>
      <div className="flex 2xl:flex-row xl:flex-row lg:flex-row md:flex-row sm:flex-row flex-col justify-center mt-[-4.5rem] mb-[2rem]">
        {steps.map((step, index) => {
          return (
            <div key={index} className="flex flex-col mx-5 items-center 3] 2xl:w-[15%] xl:w-[15%] lg:w-[15%] md:[20%] w-full" >
              <span
                className={`text-center ${
                  current === step.number ? "text-[#007E8C]" : "text-[#F1B51F]"
                }  font-bold text-4xl mb-2`}
              >
                {step.number}
              </span>
              <button
                className={`${
                  current === step.number ? "bg-[#007E8C]" : "bg-[#FEBB12]"
                }  text-sm border-[3px] text-white border-[#FFD700]  py-2 rounded-full 2xl:w-full xl:w-full lg:w-full md:w-full sm:w-full w-1/2  font-bold`}
              >
                {step.name}
              </button>
            </div>
          );
        })}
      </div>

      {children}
    </div>
  );
}

export default Stepper;


